




























import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputText'
})
export default class InputText extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
